import { render, staticRenderFns } from "./VueContainer.vue?vue&type=template&id=2cc4d8ac&scoped=true&"
import script from "./VueContainer.vue?vue&type=script&lang=js&"
export * from "./VueContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc4d8ac",
  null
  
)

export default component.exports